// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
.map-switch {
  position: absolute;
  top: 7em;
  z-index: 1;
  width: 100%;
  text-align: center;
  align-items: center;
  border-radius: 13px;
  min-height: 88px;
}
@media (max-width: 560px) {
  .map-switch {
    top: 5.5em !important;
  }
}
.map-switch .container {
  background-color: #fff;
  padding: 1em 2em;
  border-radius: 13px;
  border: 1px solid #dedede;
}
.map-switch a {
  text-decoration: none;
  color: var(--undp-jtf-text-color);
}
.map-switch a:hover {
  text-decoration: none;
  color: var(--undp-jtf-text-color);
}
.map-switch li {
  margin-right: 15px;
  font: normal normal normal 14px/16px "OpenSans-Regular";
  cursor: pointer;
}
.map-switch li span {
  color: var(--undp-jtf-text-color);
  font: normal normal bold 14px/16px "OpenSans-Regular";
}
.map-switch li span:hover {
  text-decoration: none;
}
.map-switch li.active {
  font: normal normal bold 14px/16px "OpenSans-Regular";
}
.map-switch li.active span {
  color: var(--undp-jtf-btn-dark-color);
  border-bottom: 4px solid;
}
.map-switch .switch-description {
  margin-top: 1rem;
  color: var(--undp-jtf-text-color);
}
.map-switch .switch-description .left {
  float: left;
  font: normal normal normal 14px/14px "OpenSans-Light";
}
.map-switch .switch-description .right {
  float: right;
}
.map-switch .switch-description .right .switch-buttons-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.map-switch .switch-description .right .switch-buttons {
  font: normal normal normal 14px/16px "OpenSans-Regular";
  color: var(--undp-jtf-text-color);
  cursor: pointer;
  display: inline-flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.map-switch .switch-description .right .switch-buttons .active {
  background-color: var(--undp-jtf-btn-dark-color);
  color: #fff;
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 55, 112, 0.2);
}
.map-switch .switch-description .right .switch-buttons .active a {
  color: #fff;
}
.map-switch .switch-description .right .switch-buttons span {
  padding: 9px 26px;
  transition: all 0.3s ease;
  border-right: 1px solid #e2e8f0;
}
.map-switch .switch-description .right .switch-buttons span:last-child {
  border-right: none;
}
.map-switch .switch-description .right .switch-buttons span:hover:not(.active) {
  background-color: rgba(0, 55, 112, 0.05);
  transform: translateY(-1px);
}
.map-switch .switch-description .right .switch-buttons span:nth-child(1).active {
  border-radius: 7px 0 0 7px;
}
.map-switch .switch-description .right .switch-buttons span:nth-child(2).active {
  border-radius: 0 7px 7px 0;
}
.map-switch .switch-description .right .switch-buttons-secondary {
  text-align: right;
  max-width: 100%;
}
.map-switch .switch-description .right .switch-buttons-secondary__hint {
  display: block;
  font: normal normal normal 11px/1.3 "OpenSans-Regular";
  color: #64748b;
  margin-bottom: 6px;
  letter-spacing: 0.02em;
}
.map-switch .switch-description .right .switch-buttons-secondary__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px dashed rgba(0, 55, 112, 0.38);
  border-radius: 8px;
  font: normal normal normal 13px/1.35 "OpenSans-Regular";
  cursor: pointer;
  text-decoration: none;
  color: var(--undp-jtf-text-color);
  background: #f8fafc;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.map-switch .switch-description .right .switch-buttons-secondary__link:hover:not(.active) {
  background: rgba(0, 55, 112, 0.06);
  border-color: rgba(0, 55, 112, 0.55);
}
.map-switch .switch-description .right .switch-buttons-secondary__link.active {
  border-style: solid;
  background-color: var(--undp-jtf-btn-dark-color);
  color: #fff;
  border-color: var(--undp-jtf-btn-dark-color);
}
.map-switch .switch-description .right .switch-buttons-secondary__link.active .switch-buttons-secondary__icon {
  color: #fff;
}
.map-switch .switch-description .right .switch-buttons-secondary__icon {
  flex-shrink: 0;
  font-size: 14px;
  opacity: 0.9;
}
.map-switch .switch-description .right .switch-buttons-secondary__text {
  text-align: left;
}
.map-switch .switch-description .right a {
  text-decoration: none;
}
.map-switch .switch-description .form-control {
  margin-right: 5px;
  font-family: "OpenSans-Regular";
  border-color: var(--undp-jtf-btn-dark-color);
}
.map-switch .switch-description .form-control:focus {
  box-shadow: none;
  border-color: var(--undp-jtf-btn-dark-color);
}
.map-switch .switch-description .btn-outline-primary {
  background-color: var(--undp-jtf-btn-dark-color);
  color: #fff;
  border: none;
}
.map-switch .switch-description .btn-outline-primary:focus {
  box-shadow: none;
}

@media (max-width: 992px) {
  .map-switch {
    position: absolute;
    z-index: 1;
    width: 100%;
    text-align: center;
    align-items: center;
    border-radius: 13px;
    min-height: 88px;
  }
  .map-switch .container {
    background-color: #fff;
    padding: 1em 2em;
    border-radius: 13px;
    border: 1px solid #dedede;
  }
  .map-switch a {
    text-decoration: none;
    color: var(--undp-jtf-text-color);
    line-height: 20px;
  }
  .map-switch a:hover {
    text-decoration: none;
    color: var(--undp-jtf-text-color);
  }
  .map-switch li {
    margin-right: 15px;
    font: normal normal normal 14px/16px "OpenSans-Regular";
    cursor: pointer;
  }
  .map-switch li span {
    color: var(--undp-jtf-text-color);
    font: normal normal bold 14px/16px "OpenSans-Regular";
  }
  .map-switch li span:hover {
    text-decoration: none;
  }
  .map-switch li.active {
    font: normal normal bold 14px/16px "OpenSans-Regular";
  }
  .map-switch li.active span {
    color: var(--undp-jtf-btn-dark-color);
    border-bottom: 4px solid;
  }
  .map-switch .switch-description {
    margin-top: 1rem;
    color: var(--undp-jtf-text-color);
  }
  .map-switch .switch-description .left {
    float: left;
    font: normal normal normal 13px/16px "OpenSans-Light";
  }
  .map-switch .switch-description .right {
    float: right;
  }
  .map-switch .switch-description .right .switch-buttons {
    font: normal normal normal 14px/16px "OpenSans-Regular";
    margin-top: 16px;
    color: var(--undp-jtf-text-color);
    cursor: pointer;
    display: inline-flex;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  }
  .map-switch .switch-description .right .switch-buttons .active {
    background-color: var(--undp-jtf-btn-dark-color);
    color: #fff;
    transform: scale(1.02);
    box-shadow: 0 2px 8px rgba(0, 55, 112, 0.2);
  }
  .map-switch .switch-description .right .switch-buttons .active a {
    color: #fff;
    font-size: 12px;
  }
  .map-switch .switch-description .right .switch-buttons span {
    padding: 7px 13px;
    transition: all 0.3s ease;
    border-right: 1px solid #e2e8f0;
  }
  .map-switch .switch-description .right .switch-buttons span:last-child {
    border-right: none;
  }
  .map-switch .switch-description .right .switch-buttons span:hover:not(.active) {
    background-color: rgba(0, 55, 112, 0.05);
    transform: translateY(-1px);
  }
  .map-switch .switch-description .right .switch-buttons span:nth-child(1).active {
    border-radius: 7px 0 0 7px;
  }
  .map-switch .switch-description .right .switch-buttons span:nth-child(2).active {
    border-radius: 0 7px 7px 0;
  }
  .map-switch .switch-description .right a {
    text-decoration: none;
    font-size: 12px;
  }
  .map-switch .switch-description .form-control {
    margin-right: 5px;
  }
  .map-switch .switch-description .form-control:focus {
    box-shadow: none;
    border-color: var(--undp-jtf-btn-dark-color);
  }
  .map-switch .switch-description .btn-outline-primary {
    background-color: var(--undp-jtf-btn-dark-color);
    color: #fff;
    border: none;
  }
  .map-switch .switch-description .btn-outline-primary:focus {
    box-shadow: none;
  }
}
@media (max-width: 527px) {
  .map-switch-nav-tab {
    margin-bottom: 8px;
  }
}

.map-rail-panel--mapHome {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.map-rail-toggle {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  min-width: 40px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--undp-jtf-primary-color);
  border-radius: 8px;
  background: #fff;
  color: var(--undp-jtf-primary-color);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 55, 112, 0.12);
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.map-rail-toggle:hover {
  background: var(--undp-jtf-primary-color);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 55, 112, 0.2);
}
.map-rail-toggle:focus {
  outline: 2px solid var(--undp-jtf-primary-color);
  outline-offset: 2px;
}

/* Después del bloque responsive: misma especificidad gana por orden; forzar rail izquierdo en mapa */
.map-switch.map-switch--leftRail {
  width: auto;
  max-width: min(100vw - 120px, 56rem);
  left: 1rem;
  right: auto;
  text-align: left;
  margin: 0;
  min-height: 0;
}
.map-switch.map-switch--leftRail .container {
  display: inline-block;
  width: auto;
  max-width: min(100vw - 120px, 56rem);
  padding: 0.65rem 1rem;
  vertical-align: top;
}
.map-switch.map-switch--leftRail .switch-description {
  margin-top: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.map-switch.map-switch--leftRail .switch-description .left {
  float: none;
  display: none;
}
.map-switch.map-switch--leftRail .switch-description .right {
  float: none;
  width: 100%;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons-wrap {
  align-items: stretch;
  width: 100%;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons-secondary {
  text-align: left;
  width: 100%;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons-secondary__hint {
  text-align: left;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons-secondary__link {
  width: 100%;
  justify-content: flex-start;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 6px;
  margin-top: 0;
  max-width: 100%;
  border: none;
  border-radius: 0;
  overflow: visible;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons span {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  border-right: 1px solid #e2e8f0;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons span:last-child {
  border-right: 1px solid #e2e8f0;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons span.active {
  border-radius: 8px;
}
.map-switch.map-switch--leftRail .switch-description .right .switch-buttons a {
  display: block;
  white-space: normal;
  text-align: left;
  line-height: 1.35;
}
@media (max-width: 992px) {
  .map-switch.map-switch--leftRail {
    max-width: calc(100vw - 1.25rem);
    left: 0.75rem;
  }
  .map-switch.map-switch--leftRail .container {
    max-width: calc(100vw - 1.25rem);
    padding: 0.55rem 0.75rem;
  }
  .map-switch.map-switch--leftRail .switch-buttons span {
    padding: 7px 12px;
    font-size: 12px;
  }
}

.map-switch.map-switch--leftRail.map-switch--railCollapsed {
  max-width: none;
}
.map-switch.map-switch--leftRail.map-switch--railCollapsed .container {
  padding: 0.35rem;
  min-width: 0;
}
.map-switch.map-switch--leftRail.map-switch--railCollapsed .switch-description .right {
  float: none;
  width: auto;
}
.map-switch.map-switch--leftRail.map-switch--railCollapsed .map-rail-panel--mapHome {
  gap: 0;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/header-nav/post-header-nav.component.scss","webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACE,kBAAA;EACA,QAAA;EAEA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,gBAAA;AAAF;AAME;EAjBF;IAkBI,qBAAA;EAHF;AACF;AAQE;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AANJ;AASE;EACE,qBAAA;EACA,iCAAA;AAPJ;AAQI;EACE,qBAAA;EACA,iCAAA;AANN;AAUE;EACE,kBAAA;EACA,uDAAA;EACA,eAAA;AARJ;AASI;EACE,iCAAA;EACA,qDAAA;AAPN;AAQM;EACE,qBAAA;AANR;AASI;EACE,qDAAA;AAPN;AAQM;EACE,qCAAA;EACA,wBAAA;AANR;AAWE;EACE,gBAAA;EACA,iCAAA;AATJ;AAUI;EACE,WAAA;EACA,qDAAA;AARN;AAUI;EACE,YAAA;AARN;AASM;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AAPR;AASM;EACE,uDAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAPR;AASQ;EACE,gDAAA;EACA,WAAA;EACA,sBAAA;EACA,2CAAA;AAPV;AAQU;EACE,WAAA;AANZ;AASQ;EACE,iBAAA;EACA,yBAAA;EACA,+BAAA;AAPV;AASU;EACE,kBAAA;AAPZ;AAUU;EACE,wCAAA;EACA,2BAAA;AARZ;AAYY;EACE,0BAAA;AAVd;AAcY;EACE,0BAAA;AAZd;AAkBM;EACE,iBAAA;EACA,eAAA;AAhBR;AAkBQ;EACE,cAAA;EACA,sDAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAhBV;AAmBQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,uDAAA;EACA,eAAA;EACA,qBAAA;EACA,iCAAA;EACA,mBAAA;EACA,8DAAA;AAjBV;AAmBU;EACE,kCAAA;EACA,oCAAA;AAjBZ;AAoBU;EACE,mBAAA;EACA,gDAAA;EACA,WAAA;EACA,4CAAA;AAlBZ;AAoBY;EACE,WAAA;AAlBd;AAuBQ;EACE,cAAA;EACA,eAAA;EACA,YAAA;AArBV;AAwBQ;EACE,gBAAA;AAtBV;AAyBM;EACE,qBAAA;AAvBR;AA0BI;EACE,iBAAA;EACA,+BEhLiB;EFiLjB,4CAAA;AAxBN;AAyBM;EACE,gBAAA;EACA,4CAAA;AAvBR;AA0BI;EACE,gDAAA;EACA,WAAA;EACA,YAAA;AAxBN;AAyBM;EACE,gBAAA;AAvBR;;AA6BA;EACE;IACE,kBAAA;IAGA,UAAA;IACA,WAAA;IAEA,kBAAA;IACA,mBAAA;IAEA,mBAAA;IACA,gBAAA;EA9BF;EA+BE;IACE,sBAAA;IACA,gBAAA;IACA,mBAAA;IACA,yBAAA;EA7BJ;EAgCE;IACE,qBAAA;IACA,iCAAA;IACA,iBAAA;EA9BJ;EA+BI;IACE,qBAAA;IACA,iCAAA;EA7BN;EAiCE;IACE,kBAAA;IACA,uDAAA;IACA,eAAA;EA/BJ;EAgCI;IACE,iCAAA;IACA,qDAAA;EA9BN;EA+BM;IACE,qBAAA;EA7BR;EAgCI;IACE,qDAAA;EA9BN;EA+BM;IACE,qCAAA;IACA,wBAAA;EA7BR;EAkCE;IACE,gBAAA;IACA,iCAAA;EAhCJ;EAiCI;IACE,WAAA;IACA,qDAAA;EA/BN;EAiCI;IACE,YAAA;EA/BN;EAgCM;IACE,uDAAA;IACA,gBAAA;IACA,iCAAA;IACA,eAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;EA9BR;EAgCQ;IACE,gDAAA;IACA,WAAA;IACA,sBAAA;IACA,2CAAA;EA9BV;EA+BU;IACE,WAAA;IACA,eAAA;EA7BZ;EAgCQ;IACE,iBAAA;IACA,yBAAA;IACA,+BAAA;EA9BV;EAgCU;IACE,kBAAA;EA9BZ;EAiCU;IACE,wCAAA;IACA,2BAAA;EA/BZ;EAmCY;IACE,0BAAA;EAjCd;EAqCY;IACE,0BAAA;EAnCd;EAwCM;IACE,qBAAA;IACA,eAAA;EAtCR;EAyCI;IACE,iBAAA;EAvCN;EAwCM;IACE,gBAAA;IACA,4CAAA;EAtCR;EAyCI;IACE,gDAAA;IACA,WAAA;IACA,YAAA;EAvCN;EAwCM;IACE,gBAAA;EAtCR;AACF;AA6CE;EADF;IAEI,kBAAA;EA1CF;AACF;;AA6CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;AA1CF;;AA6CA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,4CAAA;EACA,6EAAA;AA1CF;AA4CE;EACE,yCAAA;EACA,WAAA;EACA,4CAAA;AA1CJ;AA6CE;EACE,gDAAA;EACA,mBAAA;AA3CJ;;AA+CA,qGAAA;AACA;EACE,WAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;AA5CF;AA8CE;EACE,qBAAA;EACA,WAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,aAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;AA7CJ;AA+CI;EACE,WAAA;EACA,aAAA;AA7CN;AAgDM;EACE,WAAA;EACA,WAAA;AA9CR;AAgDQ;EACE,oBAAA;EACA,WAAA;AA9CV;AAiDQ;EACE,gBAAA;EACA,WAAA;AA/CV;AAiDU;EACE,gBAAA;AA/CZ;AAkDU;EACE,WAAA;EACA,2BAAA;AAhDZ;AAoDQ;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAlDR;AAoDQ;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+BAAA;AAlDV;AAoDU;EACE,+BAAA;AAlDZ;AAqDU;EACE,kBAAA;AAnDZ;AAuDQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AArDV;AA2DE;EA1FF;IA2FI,gCAAA;IACA,aAAA;EAxDF;EA0DE;IACE,gCAAA;IACA,wBAAA;EAxDJ;EA2DE;IACE,iBAAA;IACA,eAAA;EAzDJ;AACF;;AA6DA;EACE,eAAA;AA1DF;AA4DE;EACE,gBAAA;EACA,YAAA;AA1DJ;AA6DE;EACE,WAAA;EACA,WAAA;AA3DJ;AA8DE;EACE,MAAA;AA5DJ","sourcesContent":["@import '../../../../scss/variables';\n\n.map-switch {\n  position: absolute;\n  top: 7em;\n  //left: 88px;\n  z-index: 1;\n  width: 100%;\n  // background-color: #fff;\n  text-align: center;\n  align-items: center;\n  //padding: 1em;\n  border-radius: 13px;\n  min-height: 88px;\n\n  // @media (max-width: 1024px) {\n  //   top: 10.5em !important;\n  // }\n\n  @media (max-width: 560px) {\n    top: 5.5em !important;\n  }\n\n  // @media (max-width: 390px) {\n  //   top: 14em !important;\n  // }\n  .container {\n    background-color: #fff;\n    padding: 1em 2em;\n    border-radius: 13px;\n    border: 1px solid #dedede;\n  }\n\n  a {\n    text-decoration: none;\n    color: var(--undp-jtf-text-color);\n    &:hover {\n      text-decoration: none;\n      color: var(--undp-jtf-text-color);\n    }\n  }\n\n  li {\n    margin-right: 15px;\n    font: normal normal normal 14px/16px $primary-font-regular;\n    cursor: pointer;\n    span {\n      color: var(--undp-jtf-text-color);\n      font: normal normal bold 14px/16px $primary-font-regular;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n    &.active {\n      font: normal normal bold 14px/16px $primary-font-regular;\n      span {\n        color: var(--undp-jtf-btn-dark-color);\n        border-bottom: 4px solid;\n      }\n    }\n  }\n\n  .switch-description {\n    margin-top: 1rem;\n    color: var(--undp-jtf-text-color);\n    .left {\n      float: left;\n      font: normal normal normal 14px/14px $primary-font-medium;\n    }\n    .right {\n      float: right;\n      .switch-buttons-wrap {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 10px;\n      }\n      .switch-buttons {\n        font: normal normal normal 14px/16px $primary-font-regular;\n        color: var(--undp-jtf-text-color);\n        cursor: pointer;\n        display: inline-flex;\n        border: 1px solid #e2e8f0;\n        border-radius: 8px;\n        overflow: hidden;\n        \n        .active {\n          background-color: var(--undp-jtf-btn-dark-color);\n          color: #fff;\n          transform: scale(1.02);\n          box-shadow: 0 2px 8px rgba(0, 55, 112, 0.2);\n          a {\n            color: #fff;\n          }\n        }\n        span {\n          padding: 9px 26px;\n          transition: all 0.3s ease;\n          border-right: 1px solid #e2e8f0;\n          \n          &:last-child {\n            border-right: none;\n          }\n          \n          &:hover:not(.active) {\n            background-color: rgba(0, 55, 112, 0.05);\n            transform: translateY(-1px);\n          }\n          \n          &:nth-child(1) {\n            &.active {\n              border-radius: 7px 0 0 7px;\n            }\n          }\n          &:nth-child(2) {\n            &.active {\n              border-radius: 0 7px 7px 0;\n            }\n          }\n        }\n      }\n\n      .switch-buttons-secondary {\n        text-align: right;\n        max-width: 100%;\n\n        &__hint {\n          display: block;\n          font: normal normal normal 11px/1.3 $primary-font-regular;\n          color: #64748b;\n          margin-bottom: 6px;\n          letter-spacing: 0.02em;\n        }\n\n        &__link {\n          display: inline-flex;\n          align-items: center;\n          gap: 8px;\n          padding: 8px 12px;\n          border: 1px dashed rgba(0, 55, 112, 0.38);\n          border-radius: 8px;\n          font: normal normal normal 13px/1.35 $primary-font-regular;\n          cursor: pointer;\n          text-decoration: none;\n          color: var(--undp-jtf-text-color);\n          background: #f8fafc;\n          transition: background-color 0.2s ease, border-color 0.2s ease;\n\n          &:hover:not(.active) {\n            background: rgba(0, 55, 112, 0.06);\n            border-color: rgba(0, 55, 112, 0.55);\n          }\n\n          &.active {\n            border-style: solid;\n            background-color: var(--undp-jtf-btn-dark-color);\n            color: #fff;\n            border-color: var(--undp-jtf-btn-dark-color);\n\n            .switch-buttons-secondary__icon {\n              color: #fff;\n            }\n          }\n        }\n\n        &__icon {\n          flex-shrink: 0;\n          font-size: 14px;\n          opacity: 0.9;\n        }\n\n        &__text {\n          text-align: left;\n        }\n      }\n      a {\n        text-decoration: none;\n      }\n    }\n    .form-control {\n      margin-right: 5px;\n      font-family: $primary-font-regular;\n      border-color: var(--undp-jtf-btn-dark-color);\n      &:focus {\n        box-shadow: none;\n        border-color: var(--undp-jtf-btn-dark-color);\n      }\n    }\n    .btn-outline-primary {\n      background-color: var(--undp-jtf-btn-dark-color);\n      color: #fff;\n      border: none;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .map-switch {\n    position: absolute;\n    // top: 7em;\n    //left: 88px;\n    z-index: 1;\n    width: 100%;\n    // background-color: #fff;\n    text-align: center;\n    align-items: center;\n    //padding: 1em;\n    border-radius: 13px;\n    min-height: 88px;\n    .container {\n      background-color: #fff;\n      padding: 1em 2em;\n      border-radius: 13px;\n      border: 1px solid #dedede;\n      // margin-top: 38px;\n    }\n    a {\n      text-decoration: none;\n      color: var(--undp-jtf-text-color);\n      line-height: 20px;\n      &:hover {\n        text-decoration: none;\n        color: var(--undp-jtf-text-color);\n      }\n    }\n\n    li {\n      margin-right: 15px;\n      font: normal normal normal 14px/16px $primary-font-regular;\n      cursor: pointer;\n      span {\n        color: var(--undp-jtf-text-color);\n        font: normal normal bold 14px/16px $primary-font-regular;\n        &:hover {\n          text-decoration: none;\n        }\n      }\n      &.active {\n        font: normal normal bold 14px/16px $primary-font-regular;\n        span {\n          color: var(--undp-jtf-btn-dark-color);\n          border-bottom: 4px solid;\n        }\n      }\n    }\n\n    .switch-description {\n      margin-top: 1rem;\n      color: var(--undp-jtf-text-color);\n      .left {\n        float: left;\n        font: normal normal normal 13px/16px $primary-font-medium;\n      }\n      .right {\n        float: right;\n        .switch-buttons {\n          font: normal normal normal 14px/16px $primary-font-regular;\n          margin-top: 16px;\n          color: var(--undp-jtf-text-color);\n          cursor: pointer;\n          display: inline-flex;\n          border: 1px solid #e2e8f0;\n          border-radius: 8px;\n          overflow: hidden;\n          \n          .active {\n            background-color: var(--undp-jtf-btn-dark-color);\n            color: #fff;\n            transform: scale(1.02);\n            box-shadow: 0 2px 8px rgba(0, 55, 112, 0.2);\n            a {\n              color: #fff;\n              font-size: 12px;\n            }\n          }\n          span {\n            padding: 7px 13px;\n            transition: all 0.3s ease;\n            border-right: 1px solid #e2e8f0;\n            \n            &:last-child {\n              border-right: none;\n            }\n            \n            &:hover:not(.active) {\n              background-color: rgba(0, 55, 112, 0.05);\n              transform: translateY(-1px);\n            }\n            \n            &:nth-child(1) {\n              &.active {\n                border-radius: 7px 0 0 7px;\n              }\n            }\n            &:nth-child(2) {\n              &.active {\n                border-radius: 0 7px 7px 0;\n              }\n            }\n          }\n        }\n        a {\n          text-decoration: none;\n          font-size: 12px;\n        }\n      }\n      .form-control {\n        margin-right: 5px;\n        &:focus {\n          box-shadow: none;\n          border-color: var(--undp-jtf-btn-dark-color);\n        }\n      }\n      .btn-outline-primary {\n        background-color: var(--undp-jtf-btn-dark-color);\n        color: #fff;\n        border: none;\n        &:focus {\n          box-shadow: none;\n        }\n      }\n    }\n  }\n}\n\n.map-switch-nav-tab {\n  @media (max-width: 527px) {\n    margin-bottom: 8px;\n  }\n}\n\n.map-rail-panel--mapHome {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n}\n\n.map-rail-toggle {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--undp-jtf-primary-color);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--undp-jtf-primary-color);\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 55, 112, 0.12);\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    background: var(--undp-jtf-primary-color);\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 55, 112, 0.2);\n  }\n\n  &:focus {\n    outline: 2px solid var(--undp-jtf-primary-color);\n    outline-offset: 2px;\n  }\n}\n\n/* Después del bloque responsive: misma especificidad gana por orden; forzar rail izquierdo en mapa */\n.map-switch.map-switch--leftRail {\n  width: auto;\n  max-width: min(calc(100vw - 120px), 56rem);\n  left: 1rem;\n  right: auto;\n  text-align: left;\n  margin: 0;\n  min-height: 0;\n\n  .container {\n    display: inline-block;\n    width: auto;\n    max-width: min(calc(100vw - 120px), 56rem);\n    padding: 0.65rem 1rem;\n    vertical-align: top;\n  }\n\n  .switch-description {\n    margin-top: 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n\n    .left {\n      float: none;\n      display: none;\n    }\n\n      .right {\n        float: none;\n        width: 100%;\n\n        .switch-buttons-wrap {\n          align-items: stretch;\n          width: 100%;\n        }\n\n        .switch-buttons-secondary {\n          text-align: left;\n          width: 100%;\n\n          &__hint {\n            text-align: left;\n          }\n\n          &__link {\n            width: 100%;\n            justify-content: flex-start;\n          }\n        }\n\n        .switch-buttons {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        flex-wrap: nowrap;\n        gap: 6px;\n        margin-top: 0;\n        max-width: 100%;\n        border: none;\n        border-radius: 0;\n        overflow: visible;\n\n        span {\n          display: block;\n          width: 100%;\n          padding: 8px 12px;\n          border: 1px solid #e2e8f0;\n          border-radius: 8px;\n          border-right: 1px solid #e2e8f0;\n\n          &:last-child {\n            border-right: 1px solid #e2e8f0;\n          }\n\n          &.active {\n            border-radius: 8px;\n          }\n        }\n\n        a {\n          display: block;\n          white-space: normal;\n          text-align: left;\n          line-height: 1.35;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 992px) {\n    max-width: calc(100vw - 1.25rem);\n    left: 0.75rem;\n\n    .container {\n      max-width: calc(100vw - 1.25rem);\n      padding: 0.55rem 0.75rem;\n    }\n\n    .switch-buttons span {\n      padding: 7px 12px;\n      font-size: 12px;\n    }\n  }\n}\n\n.map-switch.map-switch--leftRail.map-switch--railCollapsed {\n  max-width: none;\n\n  .container {\n    padding: 0.35rem;\n    min-width: 0;\n  }\n\n  .switch-description .right {\n    float: none;\n    width: auto;\n  }\n\n  .map-rail-panel--mapHome {\n    gap: 0;\n  }\n}\n","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
